import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['select', 'name', 'redirectUri']

  applyTemplate() {
    const selectedOption = this.selectTarget.selectedOptions[0]

    if (selectedOption.value === 'custom') {
      this.nameTarget.value = ''
      this.redirectUriTarget.value = ''
    } else {
      this.nameTarget.value = selectedOption.dataset.name || ''
      this.redirectUriTarget.value = selectedOption.dataset.redirectUri || ''
    }
  }
}
